import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { getMicCamTroubleshootLink } from "modules/systemCheck/utils/getMicCamTroubleshootLink";
import { useI18n } from "i18n";
import { PermissionState } from "modules/deviceInfo";
import { OS_NAMES } from "modules/systemCheck/constants";
import {
  getPromptAssurance,
  getPromptContent,
} from "modules/audioVideo/components/DevicePromptPopup/utils";
import {
  getPermissionDeviceSubstring,
  getPermissionErrorName,
} from "../permission";
import { DetectionTestBase } from "../../DetectionTestBase";

interface Props {
  hasBlockedAudioPermissions: boolean;
  hasBlockedVideoPermissions: boolean;
  osName: OS_NAMES;
}

export const Chrome = ({
  hasBlockedAudioPermissions,
  hasBlockedVideoPermissions,
  osName,
}: Props) => {
  const { t } = useI18n(["micCamCheck", "url", "settings"]);

  const device = getPermissionDeviceSubstring(
    hasBlockedAudioPermissions,
    hasBlockedVideoPermissions,
  );

  return (
    <DetectionTestBase
      testName={t(
        getPermissionErrorName(
          !hasBlockedAudioPermissions,
          !hasBlockedVideoPermissions,
        ),
      )}
      testResult={
        <span>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t(
              getPromptContent(
                PermissionState.BLOCKED,
                hasBlockedVideoPermissions,
                hasBlockedAudioPermissions,
              ),
            )}
          </Typography>
          <br />
          <span>
            <Typography
              variant="body1"
              component="span"
              style={{ whiteSpace: "pre-line" }}
            >
              {t(`device.permissions.needed.${device}.chrome.step.1.prefix`)}
            </Typography>{" "}
            <Typography
              variant="body1"
              component="span"
              style={{ whiteSpace: "pre-line" }}
            >
              {t(`device.permissions.needed.${device}.chrome.step.1.suffix`)}
            </Typography>
          </span>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t(`device.permissions.needed.${device}.chrome.step.2`, {
              domain: window.location.host,
            })}
          </Typography>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t(`device.permissions.needed.${device}.chrome.step.3`)}
          </Typography>
          <br />
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t(
              getPromptAssurance(
                hasBlockedVideoPermissions,
                hasBlockedAudioPermissions,
              ),
            )}
          </Typography>
        </span>
      }
      troubleShootLink={t(getMicCamTroubleshootLink(osName))}
      showTroubleshootLink
      hasDivider
    />
  );
};
